import React from "react";
import { Box, Typography } from "@mui/material";
import CalendarTodayRoundedIcon from "@mui/icons-material/CalendarTodayRounded";
import EqualizerRoundedIcon from "@mui/icons-material/EqualizerRounded";
import ChatBubbleOutlineRoundedIcon from "@mui/icons-material/ChatBubbleOutlineRounded";

function toneStyles(tone) {
  if (tone === "positive") {
    return {
      borderColor: "#cfe9d9",
      backgroundColor: "#f5fbf7",
      dot: "#2d8a5f",
      iconBg: "#e3f7ec",
    };
  }
  if (tone === "warning") {
    return {
      borderColor: "#f2debc",
      backgroundColor: "#fff8ed",
      dot: "#c47a22",
      iconBg: "#fff0d4",
    };
  }
  return {
    borderColor: "#dbe7f3",
    backgroundColor: "#ffffff",
    dot: "#1f7a55",
    iconBg: "#e8f5f8",
  };
}

function getIcon(label) {
  const normalized = (label || "").toLowerCase();
  if (normalized.includes("active")) return CalendarTodayRoundedIcon;
  if (normalized.includes("actions")) return EqualizerRoundedIcon;
  return ChatBubbleOutlineRoundedIcon;
}

export default function SignalCard({ label, value, tone = "neutral", onClick = null }) {
  const palette = toneStyles(tone);
  const Icon = getIcon(label);
  const clickable = Boolean(onClick);

  return (
    <Box
      onClick={onClick || undefined}
      role={clickable ? "button" : undefined}
      tabIndex={clickable ? 0 : undefined}
      onKeyDown={
        clickable
          ? (event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                onClick();
              }
            }
          : undefined
      }
      sx={{
        minWidth: 0,
        minHeight: 76,
        borderRadius: "18px",
        border: "1px solid",
        borderColor: palette.borderColor,
        backgroundColor: palette.backgroundColor,
        px: 1.2,
        py: 1.1,
        boxShadow: "0 10px 22px rgba(15, 35, 59, 0.045)",
        cursor: clickable ? "pointer" : "default",
        transition: "transform 120ms ease, border-color 120ms ease, box-shadow 120ms ease",
        "&:hover": clickable
          ? {
              transform: "translateY(-1px)",
              borderColor: "#bdcad9",
              boxShadow: "0 14px 28px rgba(15, 35, 59, 0.07)",
            }
          : undefined,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.05 }}>
        <Box
          sx={{
            width: 38,
            height: 38,
            borderRadius: "13px",
            display: "grid",
            placeItems: "center",
            backgroundColor: palette.iconBg,
            flexShrink: 0,
          }}
        >
          <Icon sx={{ fontSize: 19, color: palette.dot }} />
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="body1" sx={{ fontWeight: 900, color: "#172540", lineHeight: 1.05, fontSize: "1.05rem" }}>
            {value}
          </Typography>
          <Typography variant="body2" sx={{ display: "block", color: "#6f8199", mt: 0.2, fontSize: "0.86rem", lineHeight: 1.25 }}>
            {label}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
